module.exports = __webpack_public_path__ + "img/lifting-station-md.72491e63.svg";